/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

// we import FastImage to get the resizeMode, not to use it as a component
// eslint-disable-next-line no-restricted-imports
import FastImage from '@d11/react-native-fast-image'
import React from 'react'
import styled, { useTheme } from 'styled-components/native'

import { FastImage as ResizedFastImage } from 'libs/resizing-image-on-demand/FastImage'
import { Tag } from 'ui/designSystem/Tag/Tag'
import { SelectableAssetProps, SizeProp } from 'ui/designSystem/types'
import { Typo } from 'ui/theme'

type StyleProps = {
  size: SizeProp
  borderRadius?: number
  withStroke?: boolean
  withShadow?: boolean
}

export const SelectableAsset = ({
  variant,
  disable = false,
  Icon,
  iconElement,
  src,
  size = 'small',
  text,
  tag,
}: SelectableAssetProps) => {
  const { designSystem, icons } = useTheme()

  const iconColor = disable
    ? designSystem.color.icon.disabled
    : designSystem.color.icon.brandPrimary

  if (variant === 'icon') {
    if (iconElement) return iconElement
    if (Icon) return <Icon color={iconColor} size={icons.sizes.standard} />
    return null
  }

  if (variant === 'image') {
    return <StyledFastImage url={src} size={size} resizeMode={FastImage.resizeMode?.cover} />
  }

  if (variant === 'text') {
    return <Typo.Body>{text}</Typo.Body>
  }

  return <Tag {...tag} />
}

const StyledFastImage = styled(ResizedFastImage)<StyleProps>(({ theme, size }) => {
  return {
    backgroundColor: theme.designSystem.color.background.subtle,
    ...theme.image.square.sizes[size],
  }
})
